import { useAxiosQuery } from "../http/useAxiosQuery";
import { useHttp } from "../http/useHttp";
import { paths } from "../generated-types";

type ServiceChargeRatesOperation =
  paths["/dashboard/contracts/{contract_shared_uuid}/service-charge-rates"]["post"];
type UseServiceChargeRatesResponse =
  ServiceChargeRatesOperation["responses"][200]["content"]["application/json"];
type ServiceChargeRatesPath = ServiceChargeRatesOperation["parameters"]["path"];

export type IServiceChargeRate = UseServiceChargeRatesResponse[number];
export type UseServiceChargeRatesInput = {
  contract_shared_uuid?: ServiceChargeRatesPath["contract_shared_uuid"];
};

export const useServiceChargeRates = ({ contract_shared_uuid }: UseServiceChargeRatesInput) => {
  const { client } = useHttp();

  const { status, isPending, isFetching, data, error, refetch } =
    useAxiosQuery<UseServiceChargeRatesResponse>({
      queryKey: ["user-service-charge-rates", { contract_shared_uuid }],
      queryFn: ({ signal }) =>
        client.post(`/contracts/${contract_shared_uuid}/service-charge-rates`, undefined, {
          signal,
        }),
      enabled: Boolean(contract_shared_uuid),
    });

  return {
    rates: (data ? data.data : []) as UseServiceChargeRatesResponse,
    status,
    isPending,
    isFetching,
    error,
    refetch,
  };
};

export type UseServiceChargeRatesReturn = ReturnType<typeof useServiceChargeRates>;
